<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md3>
          <v-card class="elevation-1">
            <v-toolbar color="white" class="elevation-0 login-toolbar">
              <v-toolbar-title>Reset Password</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn flat small color="primary" class="text-transform-none font-weight-thin" to="/login">Login</v-btn>
            </v-toolbar>
            <v-form class="pa-3" v-model="valid">
              <v-card-text>
                <v-text-field prepend-icon="lock" :append-icon="showPasswords ? 'visibility_off' : 'visibility'" :type="showPasswords ? 'text' : 'password'" v-model="password" label="Password" @click:append="showPasswords = !showPasswords" :disabled="processing" :rules="passwordRules" required autofocus></v-text-field>
                <v-text-field prepend-icon="lock" :type="showPasswords ? 'text' : 'password'" v-model="password1" label="Confirm Password" :disabled="processing" :rules="passwordRules" required></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block round :disabled="!valid || processing" :loading="processing" @click.native="resetPassword" color="primary" class="px-4">
                Reset Password
                <span slot="loader">Processing...</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <powered-by />
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>    
</template>

<script>

  import PoweredBy from '../components/PoweredBy'

  export default {
    data: () => ({
      valid: false,
      processing: false,
      password: '',
      password1: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 5 || 'Password must be more than 5 characters'
      ],
      showPasswords: false,
      token: ''
    }),
    methods: {
      resetPassword: function(){
        if (!this.passwordsMatch) {
          this.notify('passwordsMismatch', 'error')
          return
        }
        this.processing = true
        this.axios.put(this.config.apis.resetPassword, {
            password: this.password, 
            password1: this.password1,
            token: this.token
          })
          .then((response) => {

            if (response.data.success) {
              this.$router.push('/login')
              this.notify('resetPasswordSuccess', 'success')
            }
            else{
              this.processing = false
              this.notify('resetPasswordError', 'error')
            }

          })
          .catch((error) => {
            this.processing = false
          });
      }
    },
    created () {
      if (!this.$route.params.token) {
        this.$router.push('/login')
      }
      this.token = this.$route.params.token
    },
    computed: {
      passwordsMatch () {
        return this.password1.length > 4 && this.password === this.password1
      }
    },
    components: {
      'powered-by': PoweredBy
    }
  }
</script>